import { fetchPageAssets, pageAssetsError } from '../../ducks/hostedAssets.duck';
import { withPageBuilder } from '../PageBuilder/PageBuilder.duck';

export const loadData = withPageBuilder(({ pageId }, search, config, intl) => dispatch => {
  const disallowedPages = [
    intl?.messages?.['CMSPage.termsOfService'] && 'terms-of-service',
    intl?.messages?.['CMSPage.privacyPolicy'] && 'privacy-policy',
  ].filter(Boolean);

  if (disallowedPages.indexOf(pageId) !== -1) {
    return dispatch(pageAssetsError({ status: 404 }));
  }

  const pageAsset = { [pageId]: `content/pages/${pageId}.json` };
  const hasFallbackContent = false;
  return dispatch(fetchPageAssets(pageAsset, hasFallbackContent));
});
